export default __webpack_public_path__ + "static/media/article-9.116c039a.png";